import { AuthInformation } from '@/store/modules/auth';
import { GET, axios, setConfig } from '.';
import env from './env';

/**
 * @author yms
 * @description 获取用户权限验证
 * @returns AuthInformation
 */
export function getProfile(): Promise<AuthInformation> {
    const query = `query ($input: AccountTokenInput!) {
        accountToken(input: $input) {
            user {
                cid
                name
                displayName
                company
                phone
                email
                type
                bio
                secure_digest
                challenges {
                    phone
                    email
                    totp
                    wechat
                    webauthn
                }
            }
        }
    }`;
    const payload = {
        query: query,
        variables: {
            input: {
                token: null,
            },
        },
    };
    return axios.post('/graphql', payload, setConfig()).then((res) => {
        return res['data']['data']['accountToken']['user'];
    });
}
/**
 * @author yms
 * @description 退出
 * @returns AuthInformation
 */
export function logout(): Promise<void> {
    return GET(`/auth/logout`, undefined, undefined, env.userCenter);
}
